import Swiper from "swiper/bundle";

const ReviewsBox = () => {
	const block = document.querySelectorAll(".reviews-box");
	if (!block) {
		return;
	}

	block.forEach((item) => {
		const isTilesMod = item.classList.contains("reviews-box_tiles");
		const list = item.querySelector(".reviews-box__list-wrap");

		if (!isTilesMod) {
			const swiper = new Swiper(list, {
				navigation: false,
				pagination: {
					el: ".reviews-box__list-pagination",
					clickable: true
				},
				spaceBetween: 20,
				initialSlide: 0,
				slidesPerView: 1,
				loop: true,
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 16
					},
					1320: {
						slidesPerView: 3,
						spaceBetween: 16
					}
				}
			});
		}
	});
};

export default ReviewsBox;
